import { Button, Modal } from '@fabric-ds/react';
import SidebarContext from 'state/SidebarContext';
import { IconTorgetShipping16 as ShippingIcon } from '@fabric-ds/icons/react';
import { useContext, useState } from 'react';
import { SuggestShippingType } from 'types/uiTypes';

type ContentProps = {
    uiText: SuggestShippingType;
    handleRequest: () => void;
};

const ConfirmationModal = ({ uiText, handleRequest }: ContentProps) => {
    const { isOwnAd } = useContext(SidebarContext);
    const [showIsOwnAd, setShowIsOwnAd] = useState(false);
    const [open, setOpen] = useState(false);

    if (!uiText.actions) return null;
    const { confirmation, text } = uiText.actions.suggestShipping;

    const openModalHandler = () => (isOwnAd === 'true' ? setShowIsOwnAd(true) : setOpen(true));

    return (
        <>
            <Button
                className="w-full max-w-full flex items-center space-x-4 mt-24"
                onClick={openModalHandler}
            >
                <ShippingIcon />
                <span>{text}</span>
            </Button>
            {showIsOwnAd && (
                <p className="text-red-500 text-center my-4 text-12">
                    Oi sann! Du kan ikke kjøpe din egen vare.
                </p>
            )}

            <Modal
                open={open}
                title={confirmation.title}
                footer={
                    <div className="flex space-x-12">
                        <Button onClick={() => setOpen(false)} className="border-0">
                            {confirmation.actions.abort.text}
                        </Button>
                        <Button primary onClick={handleRequest}>
                            {confirmation.actions.confirm.text}
                        </Button>
                    </div>
                }
            >
                <p>{confirmation.text}</p>
            </Modal>
        </>
    );
};
export default ConfirmationModal;
